import { useLang } from "@/i18n";
import { Reveal } from "@/components/Reveal";

const DOCS = {
  privacy: {
    kicker: "PRIVACY POLICY",
    title: "Informativa sulla privacy",
    updated: "Ultimo aggiornamento: ottobre 2026",
    sections: [
      {
        h: "1. Titolare del trattamento",
        p: ["Il titolare del trattamento dei dati personali è Tech Training, con sede in Bagnaria Arsa (UD), Via Monsignor O. De Liva 5, P.IVA e C.F. 03209430309, capitale sociale 35.000,00 Euro. Per qualsiasi richiesta è possibile scrivere a info@innoversegroup.it."],
      },
      {
        h: "2. Dati raccolti",
        p: ["Tramite il modulo «Richiedi una demo» raccogliamo: nome e cognome, indirizzo email, ruolo (atleta, trainer/coach, palestra/box) e il messaggio facoltativo inviato.", "Vengono inoltre trattati dati tecnici di navigazione strettamente necessari al funzionamento e alla sicurezza del sito."],
      },
      {
        h: "3. Finalità e base giuridica",
        p: ["I dati sono utilizzati esclusivamente per rispondere alle richieste ricevute e organizzare la dimostrazione del servizio (art. 6, par. 1, lett. b GDPR), oltre che per adempiere ad eventuali obblighi di legge (art. 6, par. 1, lett. c GDPR).", "Nessun dato viene utilizzato per finalità di profilazione o marketing automatizzato."],
      },
      {
        h: "4. Conservazione",
        p: ["I dati inviati tramite il modulo sono conservati per un massimo di 24 mesi dalla richiesta, salvo diversa richiesta dell'interessato o obblighi di legge."],
      },
      {
        h: "5. Comunicazione a terzi",
        p: ["I dati non sono venduti né ceduti a terzi. Possono essere trattati da fornitori tecnici (hosting, infrastruttura cloud) nominati responsabili del trattamento ai sensi dell'art. 28 GDPR."],
      },
      {
        h: "6. Diritti dell'interessato",
        p: ["In qualsiasi momento è possibile esercitare i diritti previsti dagli artt. 15-22 GDPR: accesso, rettifica, cancellazione, limitazione, portabilità e opposizione al trattamento, scrivendo a info@innoversegroup.it.", "È inoltre possibile proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it)."],
      },
    ],
  },
  cookie: {
    kicker: "COOKIE POLICY",
    title: "Informativa sui cookie",
    updated: "Ultimo aggiornamento: ottobre 2026",
    sections: [
      {
        h: "1. Cosa sono i cookie",
        p: ["I cookie sono piccoli file di testo che i siti visitati salvano sul dispositivo dell'utente per garantire funzionalità tecniche o raccogliere informazioni statistiche."],
      },
      {
        h: "2. Cosa utilizza questo sito",
        p: ["Questo sito utilizza esclusivamente strumenti tecnici: la preferenza di lingua (IT/EN) viene salvata nell'archiviazione locale del browser e cookie tecnici necessari al corretto funzionamento e alla sicurezza del servizio.", "Non vengono utilizzati cookie di profilazione, cookie pubblicitari o strumenti di tracciamento di terze parti. Per questi strumenti tecnici non è richiesto il consenso preventivo (art. 122 Codice Privacy)."],
      },
      {
        h: "3. Come gestire le preferenze",
        p: ["È possibile cancellare in qualsiasi momento i dati tecnici salvati dal sito tramite le impostazioni del proprio browser (cancellazione dati di navigazione / archiviazione siti)."],
      },
      {
        h: "4. Riferimenti",
        p: ["Per maggiori informazioni sulla normativa: Garante per la protezione dei dati personali — www.garanteprivacy.it. Titolare: Tech Training, Bagnaria Arsa (UD), Via Monsignor O. De Liva 5, P.IVA e C.F. 03209430309 — info@innoversegroup.it."],
      },
    ],
  },
};

const Legal = ({ doc }) => {
  const { lang } = useLang();
  const d = DOCS[doc];

  return (
    <section className="legal-page section-dark" data-testid={`legal-${doc}`}>
      <div className="shell legal-content">
        <Reveal><p className="kicker">{d.kicker}</p></Reveal>
        <Reveal delay={0.08}><h1 className="legal-title">{d.title}</h1></Reveal>
        <Reveal delay={0.14}>
          <p className="legal-updated">{d.updated}</p>
          {lang === "en" && <p className="legal-note">Legal documents are provided in Italian.</p>}
        </Reveal>
        {d.sections.map((s, i) => (
          <Reveal key={s.h} delay={0.05 * i} className="legal-section">
            <h2>{s.h}</h2>
            {s.p.map((par, j) => <p key={j}>{par}</p>)}
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Legal;
